<!-- 联系我们 -->
<template>
	<Layout>
		<headerBar/>

		<div class="zk-contact">
			<div class="sub-focus">
					<div class="t2 wow fadeInDown">联系我们</div>
			</div>
		</div>
		<Content class="zk-inner">
			<Row style="font-size: 16px;">
        <Col span="12">
					<h5 style="margin-bottom: 10px;">服务支持</h5>
					<p><Icon type="ios-mail" />zgzx-chanpin@jd.com</p>
				</Col>
        <Col span="12">
					<h5 style="margin-bottom: 10px;">地址</h5>
					<p><Icon type="ios-pin" />北京市亦庄经济技术开发区科创十一街18号院B座</p>
				</Col>

				<Col span="24" style="margin-top: 40px;">
					<img src="../../../assets/images/company-position.png" alt="">
				</Col>
			</Row>
		</Content>

		<footerBar/>
	</Layout>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    headerBar: () => import("../components/headerBar/HeaderBar.vue"),
    footerBar: () => import("../components/footer/Footer.vue")
  },
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../../assets/muss/muss";
@import "../../../assets/scss/yscLogin.scss";
.sub-focus {
  height: 390px;
  background-color: #000;
  background: url(../../../assets/images/tbg2.png) top center no-repeat;
  background-size: 100%;
  text-align: center;
  color: #fff;
  .t2 {
    font-size: 36px;
    padding-top: 170px;
  }
}

.zk-inner {
  width: 800px;
	padding: 80px 0;
	margin: 0 auto;
}
</style>